import { RegisterFormCompany } from "models/register";
import React from "react";
import { Form } from "react-bootstrap";

interface RegisterCompanyFormProps {
    name?: string;
    contactName: string;
    form: RegisterFormCompany;
    error?: string;
    newCustomer?: boolean;
    setForm: (form: RegisterFormCompany) => void;
}

export default function RegisterCompanyForm({ name, contactName, form, setForm, error, newCustomer }: RegisterCompanyFormProps) {

    return (
        <div className="container w-100 h-100 bg-white p-3 p-lg-5">
            <h1 className="text-dark u-fs-40 mb-3">Ärikliendi konto loomine</h1>
            <p className="u-fs-14 text-gray-700">Võtke meiega ühendust ja küsige Teie ettevõttele või asutusele personaalne pakkumine!<br/>Kohustuslikud väljad on tähistatud TÄRNIGA <sup>*</sup></p>
            { !!error && <div className="alert alert-danger mt-2">
                <i className='alert-icon icon__info--masked bg-danger mr-2'></i> Ettevõtte registreerimine ebaõnnestus: { error }
            </div>}
            <div className="u-hr mt-4"></div>
            <div className="row">
                <div className="col-12 col-lg-6">
                    <Form.Label>
                        Ettevõtte nimi
                </Form.Label>
                <Form.Control className={''}
                    value={name}
                    disabled={true}
                    type="text" />
                </div>
                <div className="col-12 col-lg-6 mt-3 mt-lg-0">
                    <Form.Label>
                        Kontakti nimi
                </Form.Label>
                <Form.Control className={''}
                    value={contactName}
                    disabled={true}
                    type="text" />
                </div>                
            </div>
            <div className="row mt-3">
                <div className="col-12 col-lg-6">
                    <Form.Label>
                        Kontakti tel. number <sup>*</sup>
                    </Form.Label>
                    <Form.Control className={''}
                        required
                        value={form.contactPhone}
                        onChange={(e) => setForm({ ...form, contactPhone: e.target.value })}
                        type="text" />
                </div>
                <div className="col-12 col-lg-6 mt-3 mt-lg-0">
                    <Form.Label>
                        Kontakti e-post <sup>*</sup>
                    </Form.Label>
                    <Form.Control className={''}
                        required
                        value={form.contactEmail}
                        onChange={(e) => setForm({ ...form, contactEmail: e.target.value })}
                        type="text" />
                </div>                
            </div>
            { newCustomer ? <><div className="u-hr mt-5"></div>
            <Form.Check
                id='check-terms'
                custom
                type="checkbox"
                label="Soovin krediiti ja kaarti"
                className='checkbox-large mt-4'
                onChange={() => setForm({ ...form, wantCreditAndCard: !form.wantCreditAndCard })}
                checked={form.wantCreditAndCard}
            /></> : null }
            { form.wantCreditAndCard ?
            <div className="row mt-3">
                <div className="col-12 col-lg-6">
                    <Form.Label>
                        Eeldatav ostumaht kuus liitrites <sup>*</sup>
                    </Form.Label>
                    <Form.Control
                        required
                        value={form.estimatedMonthlyLiters}
                        onChange={(e) => setForm({ ...form, estimatedMonthlyLiters: e.target.value ? parseFloat(e.target.value) : undefined })}
                        type="number" />
                </div>
                <div className="col-12 col-lg-6 mt-3 mt-lg-0">
                    <Form.Label>
                        Soovitav krediit eurodes <sup>*</sup>
                    </Form.Label>
                    <Form.Control
                        required
                        value={form.wantedCredit}
                        onChange={(e) => setForm({ ...form, wantedCredit: e.target.value ? parseFloat(e.target.value) : undefined })}
                        type="number" />
                </div>
                <div className="col-12 mt-3">
                    <Form.Label>
                        Lisainfo
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={form.additionalInfo}
                        onChange={(e) => setForm({ ...form, additionalInfo: e.target.value })}
                    />
                </div>                
            </div> : null}
        </div>
    );
}